export default __webpack_public_path__ + "static/media/komunitas.101c203e.svg";